<style lang="less" scoped>
  .iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
</style>

<template>
  <page-container
    :title="$t('用户反馈')"
    cover>
    <iframe class="iframe" src="https://forms.office.com/Pages/ResponsePage.aspx?id=zTuuOHmV1E-t2rQuFJXVWlo4-UnVKVJGiRSUrW4bu0pURUI3OUtGWElJQk5UU1EzSEw4QVRPRzhIWi4u" />
  </page-container>
</template>

<script>
import PageContainer from '../../components/PageContainer'
export default {
  components: {
    PageContainer
  },
  name: 'feedback'
}
</script>
